import { Dialog } from '@mui/material';
import { applyScreenStyles } from './styles';

interface ApplyDialogProps {
  open: boolean;
  handleClose: () => void;
}
export const ApplyDialog: React.FC<ApplyDialogProps> = ({ open, handleClose, children }) => {
  return (
    <Dialog
      keepMounted={false}
      maxWidth="md"
      fullWidth
      PaperProps={{ sx: applyScreenStyles.dialog }}
      open={open}
      onClose={handleClose}
      scroll="paper"
    >
      {children}
    </Dialog>
  );
};
